export default "__VITE_ASSET__CJT0F9sw__"